export enum submissionEnvironmentActionTypes {
  SET_EMPLOYEE_NUMBER = 'SET_EMPLOYEE_NUMBER',
  SET_SUBMISSION_USER = 'SET_SUBMISSION_USER',
  SET_SUBMISSION_CONTEXT = 'SET_SUBMISSION_CONTEXT',
  SET_SUBMISSION_ATTACHMENTS = 'SET_SUBMISSION_ATTACHMENTS',
  SET_SUBMISSION_ATTACHMENTS_EXECUTED = 'SET_SUBMISSION_ATTACHMENTS_EXECUTED',
  SET_SCALE = 'SET_SCALE',
  SET_SUBMISSION_DOWNLOAD = 'SET_SUBMISSION_DOWNLOAD',
  SET_RENDERER_WIDTH = 'SET_RENDERER_WIDTH',
  SET_SUBMISSION_LANGUAGE = 'SET_SUBMISSION_LANGUAGE',
}
